import { createContext } from 'react';

const DialogTitleContext = createContext(false);

export default DialogTitleContext;
